import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Row,
  Card,
  Button,
  Divider,
  Switch,
  Input,
  Badge,
  Checkbox,
  Select,
} from "antd";
import SignatureCanvas from "react-signature-canvas";

import Message from "../../Components/common/Message";
import "./vr.css";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import {
  adBlueReading,
  fuelReading,
  refrigeratorReading,
  vehicleDefectsReturnData,
  washerReading,
} from "../../Components/common/Constants";
import AuthService from "../../Components/auth/AuthService";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, TextField, Button as UploadBtn } from "@mui/material";

import {
  ArrowLeftOutlined,
  CheckOutlined,
  CloseOutlined,
  SignatureFilled,
  StarFilled,
  WarningOutlined,
} from "@ant-design/icons";
import ReportModal from "../../Components/Modals/ReportModal";
import config from "../../Components/config";
import qs from "query-string";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";

const Auth = new AuthService();
const useStyles = makeStyles((theme) => ({
  antInput: {
    "& .ant-input": {
      height: "40px",
    },
  },
  dataSheet: {
    "& .ant-checkbox .ant-checkbox-inner": {
      width: "36px",
      height: "36px"
    },
    "& .ant-checkbox+span": {
      fontSize: '16px',
      paddingTop: '6px'
    },
    "& .ant-checkbox-checked .ant-checkbox-inner:after": {
      width: '10px',
      height: '22px'
    },
    "& .ant-switch .ant-switch-inner": {
      transition: 'padding-inline-start 0.0s ease-in-out, padding-inline-end 0.0s ease-in-out;'
    }
  }
}));

const ReturnVehicleReport = () => {
  const { pinValidity } = useSelector((state) => state?.AppState?.driverData);
  const { selectedRoute } = useSelector((state) => state?.AppState?.driverData);
  const { reportSubmit } = useSelector((state) => state?.AppState?.driverData);
  const navigate = useNavigate();
  const { TextArea } = Input;
  const { Option } = Select;
  const classes = useStyles();
  const signatureCanvasRef = useRef(null);
  const dispatch = useDispatch();
  const securityPinExists = localStorage.getItem("securityPin");
  const driverID = localStorage.getItem("driver_id");
  const vehicleID = localStorage.getItem("accident_vehicle_id");

  var layoutDispatch = useLoadingDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const [odoMeter, setOdoMeter] = useState("");
  const [fuel, setFuel] = useState("");
  const [adBlue, setAdBlue] = useState("");
  const [washer, setWasher] = useState("");
  const [refrigerator, setRefrigerator] = useState("");
  const [notes, setNotes] = useState("");
  const [signature, setSignature] = useState("");
  const [allDefectsSheet, setAllDefectsSheet] = useState([...vehicleDefectsReturnData]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDefectItem, setSelectedDefectItem] = useState({});
  const [files, setFiles] = React.useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);
  const [uploadedFilesTemp, setUploadedFilesTemp] = useState({});
  const [fuelCheck, setFuelCheck] = useState(false);
  const [tachoCheck, setTachoCheck] = useState(false);

  const clearSignature = () => {
    signatureCanvasRef.current.clear();
    setSignature('')

  };

  const saveSignature = () => {
    const signatureImage = signatureCanvasRef.current.toDataURL();
    setSignature(signatureImage);
    console.log("Signature Image:", signatureImage);
  };

  // useEffect(() => {
  //   const item = reportSubmit?.find(item => item.route_id === selectedRoute);
  //   if (item && item.status === true) {
  //     navigate('/dashboard');
  // }
  // }, []);


  const showModal = (item) => {
    setSelectedDefectItem(item);
    setIsModalOpen(true);
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
  };
  console.log("fils", files);

  const handleSubmitReport = async () => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }

    const requiredDefects = allDefectsSheet.filter(
      (defect) => defect.required && !defect.status
    );

    if (requiredDefects.length > 0) {
      setType("error");
      setLoadMessage(`Please Check the required defects before submitting the report${str}`);
      return;
    }

    if (!odoMeter) {
      setType("error");
      setLoadMessage("Please enter the odometer reading" + str);
      return;
    } else if (!fuel) {
      setType("error");
      setLoadMessage("Please select truck fuel level" + str);
      return;
    } else if (!adBlue) {
      setType("error");
      setLoadMessage("Please select ad blue level" + str);
      return;
    } else if (!refrigerator) {
      setType("error");
      setLoadMessage("Please select refrigerator fuel level" + str);
      return;
    }
    // else if (!washer) {
    //   setType("error");
    //   setLoadMessage("Please select wiper washer level" + str);
    //   return;
    // } 
    else if (!tachoCheck) {
      setType("error");
      setLoadMessage("Please check tacho removed" + str);
      return;
    } else if (!signature) {
      setType("error");
      setLoadMessage("Please Sign the report" + str);
      return;
    }

    setIsLoading(true);
    const dataToSend = {
      route_status_id: selectedRoute,
      return_odo_meter: odoMeter,
      return_fuel: fuel,
      return_ad_blue: adBlue,
      return_refrigerator_fuel: refrigerator,
      // return_wiper_washer_liquid: washer,
      notes_return: notes,
      return_signature: signature,
      deleted_files: deletedFiles,
      driver_id: JSON.parse(driverID),
      vehicle_id: JSON.parse(vehicleID),
      return_tacho: tachoCheck ? 1 : 0,
      return_fuel_card: fuelCheck ? 1 : 0,
      type: 2
    };

    allDefectsSheet.map((d) => {
      dataToSend[d.key] = d.status == true ? 1 : 0;
      dataToSend[d.key + "_images"] = d.images ? d.images : [];
      dataToSend[d.key + "_notes"] = d.notes;
      dataToSend[d.key + "_not_road_worthy"] =
        d.not_road_worthy == true ? 1 : 0;
    });

    try {
      const res = await Auth.fetch("/driverapp/vehicle-defect-sheet", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        // dispatch({type: 'SUBMIT_REPORT', payload: {route_id: selectedRoute, status: true}})
        const uploadPromises = files.map(async (f) => {
          try {
            const uploadUrl = await getUploadUrl(f);
            await uploadFileToS3(uploadUrl, f.file, f.file.type);
          } catch (error) {
            console.error("Error uploading file:", error);
          }
        });
        Promise.all(uploadPromises).then(() => {
          navigate("/routes");
          setIsLoading(false);
        });
      } else {
        setIsLoading(false);
        setType("error");
        setLoadMessage(res.message);
      }
    } catch (err) {
      console.log(err);
    }
  };
  console.log(allDefectsSheet);

  useEffect(() => {
    const initialUploadedFilesTemp = {};
    allDefectsSheet.forEach((defect) => {
      initialUploadedFilesTemp[defect.key] = [];
    });
    setUploadedFilesTemp(initialUploadedFilesTemp);
  }, []);

  const getDataByRouteID = async () => {
    dispatch({ type: "LOADING", payload: true });
    showLoading(layoutDispatch);
    try {
      const { check_defect_sheet } = await Auth.fetch(
        `/driverapp/vehicle-defect-sheet?route_status_id=${selectedRoute}&driver_id=${driverID}&vehicle_id=${vehicleID}`
      );
      if (check_defect_sheet.length) {
        let newDefectSheet = check_defect_sheet.find((item => item.type == 2));
        if (!newDefectSheet) newDefectSheet = check_defect_sheet.find((item => item.type == 1))
        setAllDefectsSheet((prevDefects) => {
          return Object.entries(newDefectSheet).reduce(
            (updatedDefects, [key, value]) => {
              const defectIndex = updatedDefects.findIndex(
                (defect) =>
                  defect.key ===
                  key.replace(/(_notes|_images|_not_road_worthy)$/, "")
              );
              if (defectIndex !== -1) {
                const updatedDefect = { ...updatedDefects[defectIndex] };
                if (key.endsWith("_notes")) {
                  updatedDefect.notes = value;
                } else if (key.endsWith("_images")) {
                  updatedDefect.images = JSON.parse(value);
                } else if (key.endsWith("_not_road_worthy")) {
                  updatedDefect.not_road_worthy = value === 1 ? true : false;
                } else {
                  updatedDefect.status = value === 1;
                }
                updatedDefects[defectIndex] = updatedDefect;
              }
              return updatedDefects;
            },
            [...prevDefects]
          );
        });
        setNotes(newDefectSheet?.notes_return);
        setTachoCheck(newDefectSheet?.return_tacho == 1 ? true : false);
        setFuelCheck(newDefectSheet?.return_fuel_card == 1 ? true : false);
        setSignature(newDefectSheet?.return_signature);
        setOdoMeter(newDefectSheet?.return_odo_meter);

        setFuel(newDefectSheet?.return_fuel);

        setAdBlue(newDefectSheet?.return_ad_blue);

        setRefrigerator(newDefectSheet?.return_refrigerator_fuel);

        setWasher(newDefectSheet?.return_wiper_washer_liquid);
      } else {
        setAllDefectsSheet([...vehicleDefectsReturnData]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      dispatch({ type: "LOADING", payload: false });
      hideLoading(layoutDispatch);

    }
  };

  useEffect(() => {
    getDataByRouteID();
  }, []);

  if (!pinValidity) {
    localStorage.removeItem("DriverName");
    localStorage.removeItem("securityPin");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    navigate("/pin");
    localStorage.setItem('routeLocation', false)
    dispatch({ type: "RESET_STATE" });
  }

  if (!securityPinExists) {
    navigate("/pin");
    localStorage.removeItem("DriverName");
    localStorage.removeItem("driverRoutes");
    localStorage.removeItem("route_name");
    localStorage.removeItem("driver_id");
    localStorage.setItem('routeLocation', false)
    dispatch({ type: "RESET_STATE" });
  }

  const handleSwitchToggle = (itemID, isChecked) => {
    setAllDefectsSheet((prevDefects) => {
      const updatedDefects = prevDefects.map((defect) =>
        defect.id === itemID ? { ...defect, status: isChecked } : defect
      );
      return updatedDefects;
    });
  };
  console.log("filess", files);

  const getUploadUrl = async (file) => {
    const params = {
      bucket: config.tms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/defect_sheets/" + selectedRoute + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  console.log("deletedFiles", deletedFiles);
  return (
    <div className={classes.dataSheet}>
      <Row style={{ display: "flex", justifyContent: 'start' }}>
        <Button size="large" icon={<ArrowLeftOutlined />} onClick={() => navigate("/routes")}>Back</Button>
      </Row>
      <h2 className="report-box-heading">Vehicle Defect Report On Return</h2>
      <>
      <Row gutter={[16, 16]}>
  {allDefectsSheet?.map((item, index) => {
    const isLastItem = index === allDefectsSheet?.length - 1; 
    return (
      <React.Fragment key={item.id}>
        {!isLastItem && (
          <Col xs={24} sm={16} md={12} lg={8} xl={6}>
            <Card
              size="small"
              style={{
                minWidth: 250,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Switch
                    style={{
                      backgroundColor: item.status ? "green" : "#FF2E2E",
                      marginRight: "10px",
                    }}
                    checkedChildren={<CheckOutlined />}
                    unCheckedChildren={<CloseOutlined />}
                    checked={item.status}
                    onChange={(checked) => handleSwitchToggle(item.id, checked)}
                  />
                  <span
                    style={{
                      fontSize: "12px",
                      marginRight: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    {item.title}
                    <span style={{ color: "red", fontSize: "15px" }}>
                      {item.required && "*"}
                    </span>
                  </span>
                </div>
                <div>
                  {item.not_road_worthy && (
                    <WarningOutlined
                      style={{
                        fontSize: "20px",
                        color: "red",
                        marginRight: "5px",
                      }}
                    />
                  )}
                  <UploadBtn
                    component="label"
                    sx={{ padding: "0", minWidth: "30px", marginRight: "15px" }}
                    onClick={() => showModal(item)}
                  >
                    <Badge
                      color="#1890ff"
                      dot={item.images?.length > 0 || item?.notes}
                    >
                      <SignatureFilled
                        style={{ fontSize: "25px", color: "grey" }}
                      />
                    </Badge>
                  </UploadBtn>
                </div>
              </div>
            </Card>
          </Col>
        )}

        {isLastItem && (
          <>
            <Divider />
              <Col xs={24} sm={16} md={12} lg={8} xl={6}>
                <Card
                  size="small"
                  style={{
                    minWidth: 250,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Switch
                        style={{
                          backgroundColor: item.status ? "green" : "#FF2E2E",
                          marginRight: "10px",
                        }}
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        checked={item.status}
                        onChange={(checked) =>
                          handleSwitchToggle(item.id, checked)
                        }
                      />
                      <span
                        style={{
                          fontSize: "12px",
                          marginRight: "5px",
                          fontWeight: "bold",
                        }}
                      >
                        {item.title}
                        <span style={{ color: "red", fontSize: "15px" }}>
                          {item.required && "*"}
                        </span>
                      </span>
                    </div>
                    <div>
                      {item.not_road_worthy && (
                        <WarningOutlined
                          style={{
                            fontSize: "20px",
                            color: "red",
                            marginRight: "5px",
                          }}
                        />
                      )}
                      <UploadBtn
                        component="label"
                        sx={{
                          padding: "0",
                          minWidth: "30px",
                          marginRight: "15px",
                        }}
                        onClick={() => showModal(item)}
                      >
                        <Badge
                          color="#1890ff"
                          dot={item.images?.length > 0 || item?.notes}
                        >
                          <SignatureFilled
                            style={{ fontSize: "25px", color: "grey" }}
                          />
                        </Badge>
                      </UploadBtn>
                    </div>
                  </div>
                </Card>
              </Col>
          </>
        )}
      </React.Fragment>
    );
  })}
</Row>
      </>
      <Divider />
      <Row gutter={[16, 4]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Odometer<span style={{ color: "red", fontSize: "20px" }}>*</span>
          </h4>
          <div className={classes.antInput}>
            <Input
              placeholder="Enter odometer reading"
              onChange={(e) => setOdoMeter(e.target.value)}
              value={odoMeter}
              type="number"
            />
          </div>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Truck Fuel Level
            <span style={{ color: "red", fontSize: "20px" }}>*</span>
          </h4>
          <Select
            style={{
              width: "100%",
            }}
            size="large"
            value={fuel}
            placeholder="Select Fuel Reading"
            onChange={(value) => {
              setFuel(value);
            }}
          >
            {fuelReading.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        </Col>

        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            AdBlue Level
            <span style={{ color: "red", fontSize: "20px" }}>*</span>
          </h4>
          <Select
            style={{
              width: "100%",
            }}
            size="large"
            value={adBlue}
            placeholder="Select Ad Blue Reading"
            onChange={(value) => {
              setAdBlue(value);
            }}
          >
            {adBlueReading.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
            Refrigerator Fuel level
            <span style={{ color: "red", fontSize: "20px" }}>*</span>
          </h4>
          <Select
            style={{
              width: "100%",
            }}
            size="large"
            value={refrigerator}
            placeholder="Select Refrigerator Fuel level"
            onChange={(value) => {
              setRefrigerator(value);
            }}
          >
            {refrigeratorReading.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Checkbox
            checked={fuelCheck}
            onChange={(e) => {
              setFuelCheck(e.target.checked);
            }}
            size={36}
          >
            Fuel Card Returned
          </Checkbox>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: "15px" }}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
          <Checkbox
            checked={tachoCheck}
            onChange={(e) => {
              setTachoCheck(e.target.checked);
            }}
            size="large"
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <span>Tacho Removed</span>
              <span style={{ color: "red", fontSize: "20px" }}>*</span>
            </div>
          </Checkbox>
        </Col>
      </Row>

      <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>Notes</h4>
      <div style={{ marginBottom: "10px" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <TextArea
              autoSize={{ minRows: 6, maxRows: 12 }}
              label="Notes"
              placeholder="Enter Any Specific Notes"
              onChange={(e) => setNotes(e.target.value)}
              value={notes}
            />
          </Col>
        </Row>
      </div>
      {/* <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
        Signature<span style={{ color: "red", fontSize: "20px" }}>*</span>
      </h4> */}
      <div
        style={{
          width: 390,
          display: "flex",
          alignItems: 'end',
          justifyContent: "space-between",
          marginTop: "15px",
        }}
      >
        <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
          Signature<span style={{ color: "red", fontSize: "15px" }}>*</span>
        </h4>
        <Button
          size="large"
          danger
          onClick={clearSignature}
        >
          Clear Signature
        </Button>
      </div>
      <div className="sign-con">
        <SignatureCanvas
          ref={signatureCanvasRef}
          value={signature}
          penColor="purple"
          canvasProps={{
            width: 390,
            height: 200,
            className: "signature-canvas",
          }}
          onEnd={saveSignature}
        />
        <div>
          {signature && <img height={150} width={250} src={signature} />}
        </div>
      </div>
      <div
        style={{
          width: 390,
          display: "flex",
          justifyContent: "space-between",
          marginTop: "15px",
        }}
      >
        {/* <Button size="large" onClick={clearSignature}>Clear Signature</Button> */}
        {/* <Button size="large" type="primary" onClick={saveSignature}>
          Save Signature
        </Button> */}
      </div>
      <Divider />
      <div className="box-button" style={{ marginTop: "15px" }}>
        <Button
          style={{
            height: "40px",
            width: "150px",
            padding: "4px",
            fontSize: "15px",
          }}
          size="large"
          type="primary"
          loading={isLoading}
          onClick={handleSubmitReport}
        >
          Submit
        </Button>
      </div>
      {/* </div> */}

      <Message type={type} msg={loadMessage} />
      <ReportModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        selectedDefectItem={selectedDefectItem}
        setAllDefectsSheet={setAllDefectsSheet}
        allDefectsSheet={allDefectsSheet}
        setFiles={setFiles}
        files={files}
        setDeletedFiles={setDeletedFiles}
        deletedFiles={deletedFiles}
        uploadedFilesTemp={uploadedFilesTemp}
        setUploadedFilesTemp={setUploadedFilesTemp}
      />
    </div>
  );
};

export default ReturnVehicleReport;
